import {
  GET_CIVILBUDGETDETAIL,
  GET_CIVILBUDGETDETAIL_SUCCESS,
  GET_CIVILBUDGETDETAIL_FAIL,
  DELETE_CIVILBUDGETDETAIL,
  DELETE_CIVILBUDGETDETAIL_SUCCESS,
  DELETE_CIVILBUDGETDETAIL_FAIL,
  UPDATE_CIVILBUDGETDETAIL,
  UPDATE_CIVILBUDGETDETAIL_SUCCESS,
  UPDATE_CIVILBUDGETDETAIL_FAIL,
  ADD_NEW_CIVILBUDGETDETAIL,
  ADD_CIVILBUDGETDETAIL_SUCCESS,
  ADD_CIVILBUDGETDETAIL_FAIL,
  CIVILBUDGETDETAIL_LOADING,
  CIVILBUDGETDETAIL_RESET
} from "./actionType";

export const resetCivilBudgetDetailState = (actionType) => ({
  type: CIVILBUDGETDETAIL_RESET,
  payload: { actionType },
});

export const getCivilBudgetDetailSuccess = (actionType, data) => ({
  type: GET_CIVILBUDGETDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getCivilBudgetDetailFail = (actionType, error) => ({
  type: GET_CIVILBUDGETDETAIL_FAIL,
  payload: { actionType, error },
});

export const getCivilBudgetDetail = data => ({
  type: GET_CIVILBUDGETDETAIL,
  payload: data,
});

export const getCivilBudgetDetailLoading = () => ({
  type: CIVILBUDGETDETAIL_LOADING
});

export const deleteCivilBudgetDetail = data => ({
  type: DELETE_CIVILBUDGETDETAIL,
  payload: data,
});

export const deleteCivilBudgetDetailSuccess = data => ({
  type: DELETE_CIVILBUDGETDETAIL_SUCCESS,
  payload: data,
});

export const deleteCivilBudgetDetailFail = error => ({
  type: DELETE_CIVILBUDGETDETAIL_FAIL,
  payload: error,
});

export const updateCivilBudgetDetail = data => ({
  type: UPDATE_CIVILBUDGETDETAIL,
  payload: data,
});

export const updateCivilBudgetDetailFail = error => ({
  type: UPDATE_CIVILBUDGETDETAIL_FAIL,
  payload: error,
});

export const updateCivilBudgetDetailSuccess = data => ({
  type: UPDATE_CIVILBUDGETDETAIL_SUCCESS,
  payload: data,
});

export const addNewCivilBudgetDetail = data => ({
  type: ADD_NEW_CIVILBUDGETDETAIL,
  payload: data,
});

export const addCivilBudgetDetailSuccess = data => ({
  type: ADD_CIVILBUDGETDETAIL_SUCCESS,
  payload: data,
});

export const addCivilBudgetDetailFail = error => ({
  type: ADD_CIVILBUDGETDETAIL_FAIL,
  payload: error,
});